import { useState, useEffect } from 'react';
import { REGEX_DATE } from './../constants';

export const useDate = (value: string) => {
  let day = new Date().getDate();
  let month = new Date().getMonth();
  let year = new Date().getFullYear();
  const [ date, setDate ] = useState({
    day,
    month,
    year
  });

  const isDate = REGEX_DATE.test(value);

  if(isDate) {
    const [ newDay, newMonth, newYear ] = value.split('/');
    day = parseInt(newDay);
    month = parseInt(newMonth) - 1;
    year = parseInt(newYear);
  }

  useEffect(() => {
    setDate({
      day,
      month,
      year
    });
  }, [value]);

  return date;
};
